export const ROOT_NODE_ID = "0";

export const SEGMENT_ROOT_NODE_ID = "1";

export const SEGMENT_TRY_AGAIN_NODE_ID = "ask_to_try_again_block";

export const SEGMENT_VALIDATION_NODE_ID = "validation_block";

export const BLOCK_PREFIX = "BLOCK";

export const EMPTY_OUTGOING_MESSAGE_PLACEHOLDER = "Agrega un mensaje...";

export const DEFAULT_PLACEHOLDER_OUTGOING_MESSAGE =
  "👋 Algo sucedió,\nNo has completado tu conversación para esta respuesta";

export const FIRST_OPTION_NUMBER_MULTIPLE_BLOCK = 1;

export const DEFAULT_STROKE_COLOR = "#0468FD";

export const WHATSAPP_BASE_URL = "https://wa.me";

export const WHATSAPP_PHONE_NUMBER = "16196586276";

export const BlockTypesLabels: Record<BlockType, string> = {
  root: "Bloque Inicio",
  placeholder: "Bloque vacío",
  simple: "Bloque Sencillo",
  multiple: "Múltiples Respuestas",
  recursive: "Bloque Recursivo",
  finish: "Finalizar",
  background_check: "Validación de Antecedentes",
  document_validation_segment: "Documentos",
  email_validation_segment: "Correo Electrónico",
  phone_validation_segment: "Teléfono",
};

export const AvailableBlockTypesLabels: Record<BlockType, boolean> = {
  root: false,
  placeholder: false,
  simple: true,
  multiple: true,
  recursive: true,
  finish: true,
  background_check: true,
  document_validation_segment: true,
  email_validation_segment: true,
  phone_validation_segment: true,
};

export const SegmentBlockTypes: Record<BlockType, boolean> = {
  root: false,
  placeholder: false,
  simple: false,
  multiple: false,
  recursive: false,
  finish: false,
  background_check: false,
  document_validation_segment: true,
  email_validation_segment: true,
  phone_validation_segment: true,
};

export const OptionColors: string[] = [
  // start of official colors list
  "#0468FD",
  "#ffbc00",
  "#f95a59",
  "#12d67d",
  "#faa6ff",
  "#5f17a7",
  "#FEE08D",
  "#64DFEE",
  "#A3B7FF",
  "#592941",
  "#F89D7C",
  "#1b998b",
  "#8776B3",
  // "#0091ff",
  // "#4453E2",
  // "#201D1E",
  // end of official colors list
  "#00FFFF",
  "#AFEEEE",
  "#7FFFD4",
  "#5F9EA0",
  "#B0C4DE",
  "#87CEEB",
  "#00BFFF",
  "#1E90FF",
  "#6495ED",
  "#7B68EE",
  "#4169E1",
  "#0000FF",
  "#191970",
  "#D2691E",
];
